import './AnalyticsBlock.css';

function numberWithSpaces(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

function AnalyticsBlock({ className, title, number, percentage, type, stateSection, hoverInfo}) {


    var classNameDetails = 'details';
    var classNameArrow = '';
    if(percentage > 0) {
        classNameDetails = classNameDetails + ' up'
        classNameArrow =  'arrow up'
    }

    if(percentage < 0) {
        classNameDetails = classNameDetails + ' down'
        classNameArrow =  'arrow down'
    }

    const [section, setSection] = stateSection


    if(isNaN(number) == false) {
        number = Math.round(number * 100) / 100;
        number = numberWithSpaces(number);
    }

    const active = type == section;

    className = className ? 'block ' + className : 'block'
    className = active ? className + ' active' : className
    return (
        <div className={className} onClick={() => setSection(type != section ? type : null)} title={hoverInfo}>
            <p className='title'>{title}</p>
            <div className='block_container'>
                <span className='number'>{number}</span>
                <span className={classNameDetails}>
                { /* <div className={classNameArrow}></div> */}
                    { /* <span>{percentage}%</span> */}
                </span>
            </div>
        </div>
    )
}

AnalyticsBlock.defaultProps = {
    className : '',
    title : 'Block',
    number : 0,
    percentage : 0,
    type : '',
    stateSection : []
}

export default AnalyticsBlock;